// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from '../../Modals/Modal';

import '../../../styles/investments-filters.css';

export default class InvestmentModal extends Modal {

    state = {
    }


    renderContent = () => {
        return (
            <div
                className="modal-content modal-center"
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...(this.props?.compact ? {paddingBottom: 0, paddingTop: 10} : {}) }}
            >
                {this.props.children}
            </div>
        );
    }
};